// Game configuration types for the Critique & Coach mini-game editor

export interface AnswerOption {
  label: string; // A, B, C, D
  text: string;
  correct: boolean;
  feedback: string;
  rewrite?: string; // Optional example/rewrite
}

export interface Round {
  id: string;
  questionText: string; // Main scenario shown to player (e.g., "Outcome Goal: By the end of this quarter...")
  prompt: string; // Question asked (e.g., "Is anything amiss in this goal?")
  options: AnswerOption[];
}

export interface CongratulatoryMessage {
  minPercent: number;
  maxPercent: number;
  message: string;
}

export interface GameSettings {
  pointsPerCorrect: number;
  timerEnabled: boolean;
  timePerRound: number; // seconds
  allowReplay: boolean;
  congratulatoryMessages: CongratulatoryMessage[];
  correctLabel: string; // e.g., "Well done!"
  incorrectLabel: string; // e.g., "Not quite"
  showAnswerGuidance: boolean; // Global toggle for answer guidance
  answerGuidanceHeading: string; // e.g., "Strong Goal Example"
}

export interface GameConfig {
  // Version for migration
  version: number;
  
  // General Info
  title: string;
  subtitle: string;
  characterName?: string; // Optional
  topicSubtitle?: string; // Optional

  // Rounds
  rounds: Round[];

  // Settings
  settings: GameSettings;
}

export const DEFAULT_GAME_CONFIG: GameConfig = {
  version: 1,
  title: "",
  subtitle: "",
  characterName: undefined,
  topicSubtitle: undefined,
  rounds: [
    {
      id: "round-1",
      questionText: "",
      prompt: "",
      options: [
        { label: "A", text: "", correct: false, feedback: "", rewrite: "" },
        { label: "B", text: "", correct: false, feedback: "", rewrite: "" }
      ]
    }
  ],
  settings: {
    pointsPerCorrect: 100,
    timerEnabled: true,
    timePerRound: 30,
    allowReplay: true,
    correctLabel: "Well done!",
    incorrectLabel: "Not quite",
    showAnswerGuidance: false,
    answerGuidanceHeading: "Strong Goal Example",
    congratulatoryMessages: [
      { minPercent: 0, maxPercent: 33, message: "" },
      { minPercent: 34, maxPercent: 66, message: "" },
      { minPercent: 67, maxPercent: 100, message: "" }
    ]
  }
};

export const OPTION_LABELS = ["A", "B", "C", "D"] as const;
